import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useCreateChangelog } from "@/lib/api/changelog";
import { ChangelogForm } from "./changelog-form";

export function CreateChangelogDialog() {
  const [open, setOpen] = useState(false);
  const { mutateAsync, isPending } = useCreateChangelog();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="gap-2">
          <Plus className="size-4" />
          New update
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Create changelog entry</DialogTitle>
        </DialogHeader>
        <ChangelogForm
          submitLabel="Save draft"
          isSubmitting={isPending}
          onCancel={() => setOpen(false)}
          onSubmit={async (values) => {
            await mutateAsync(values);
            setOpen(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
